<template functional>
    <span
        class="VCheckbox noselect"
        :class="{'VCheckbox_active':props.checked,'VCheckbox_disabled':props.disabled}"
        v-on="listeners.click ? { click: listeners.click } : null"
    >
    </span>
</template>

<script>
    export default {
        name: 'VCheckbox',
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            checked: {
                type: Boolean,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        
    };
</script>

<style
    scoped
    lang="scss"
>
    .VCheckbox {
        display: inline-block;
        cursor: pointer;
        padding: 10px;
        white-space: nowrap;
        border: 1px solid $primary-color;
        border-radius: 2px;
        
        &_active {
            background: $primary-color;
        }
        &_disabled {
            opacity: .5 !important;
            cursor: not-allowed;
        }
    }
</style>